<template lang="html">
  <div>

    <div class="uk-child-width-expand@m" uk-grid>
      <div>
        <div class="uk-card uk-card-default uk-card-body">
          <h3 class="uk-card-title">Kartoteka pacjenta</h3>
          <table class="uk-table uk-table-small uk-table-striped">
            <tr>
              <td><strong>Nazwisko</strong></td>
              <td><span>{{Pacjent.Nazwisko}}</span></td>
            </tr>
            <tr>
              <td><strong>Imię</strong></td>
              <td><span>{{Pacjent.Imie}}</span></td>
            </tr>
            <tr>
              <td><strong>Drugie imię</strong></td>
              <td><span>{{Pacjent.Imie2}}</span></td>
            </tr>
            <tr>
              <td><strong>PESEL</strong></td>
              <td><span>{{Pacjent.PESEL}}</span></td>
            </tr>
            <tr>
              <td><strong>Data urodzenia</strong></td>
              <td><span>{{Pacjent.DataUr}}</span></td>
            </tr>
            <tr>
              <td><strong>Miejsce urodzenia</strong></td>
              <td><span>{{Pacjent.MiejsceUr}}</span></td>
            </tr>
            <tr>
              <td><strong>Telefon kom.</strong></td>
              <td><span>{{Pacjent.TelKom}}</span></td>
            </tr>
            <tr>
              <td><strong>Telefon dom</strong></td>
              <td><span>{{Pacjent.Tel}}</span></td>
            </tr>
            <tr>
              <td><strong>Email</strong></td>
              <td><span>{{Pacjent.Email}}</span></td>
            </tr>
          </table>

          <div>
            <button uk-toggle="target: #pass-change-modal" type="button" class="uk-button uk-button-default uk-button-small uk-margin-small-right uk-margin-small-top">Zmień hasło</button>
            <button uk-toggle="target: #email-patient-reminder-modal" type="button" class="uk-button uk-button-default uk-button-small uk-margin-small-right uk-margin-small-top">Edytuj Email</button>
            <router-link class="uk-button uk-button-default uk-button-small uk-margin-small-top" :to="{ name: 'contact', params: {} }">Chcę poprawić swoje dane</router-link>
          </div>

          <h3 class="uk-card-title">Adres zameldowania</h3>
          <table class="uk-table uk-table-small uk-table-striped">
            <tr>
              <td><strong>Kod. Poczta</strong></td>
              <td><span>{{Pacjent.KodPocztowy}} </span><span>{{Pacjent.Poczta}}</span></td>
            </tr>

            <tr>
              <td><strong>Miejscowość</strong></td>
              <td><span>{{Pacjent.Miejscowosc}}</span></td>
            </tr>
            <tr>
              <td><strong>Ulica</strong></td>
              <td><span>{{Pacjent.UlicaAlejaPlac}} </span><span>{{Pacjent.Ulica}}</span></td>
            </tr>
            <tr>
              <td><strong>Numer domu</strong></td>
              <td><span>{{Pacjent.NrDomu}}</span></td>
            </tr>
            <tr>
              <td><strong>Numer lokalu</strong></td>
              <td><span>{{Pacjent.NrMieszkania}}</span></td>
            </tr>
            <tr>
              <td><strong>Kraj</strong></td>
              <td><span>{{Pacjent.Kraj}}</span></td>
            </tr>
          </table>

          <h3 class="uk-card-title">Adres korespondencyjny</h3>
          <table class="uk-table uk-table-small uk-table-striped">
            <tr>
              <td><strong>Kod. Poczta</strong></td>
              <td><span>{{Pacjent.KodPocztowy2}} </span><span>{{Pacjent.Poczta2}}</span></td>
            </tr>

            <tr>
              <td><strong>Miejscowość</strong></td>
              <td><span>{{Pacjent.Miejscowosc2}}</span></td>
            </tr>
            <tr>
              <td><strong>Ulica</strong></td>
              <td><span>{{Pacjent.UlicaAlejaPlac2}} </span><span>{{Pacjent.Ulica2}}</span></td>
            </tr>
            <tr>
              <td><strong>Numer domu</strong></td>
              <td><span>{{Pacjent.NrDomu2}}</span></td>
            </tr>
            <tr>
              <td><strong>Numer lokalu</strong></td>
              <td><span>{{Pacjent.NrMieszkania2}}</span></td>
            </tr>
          </table>

        </div>
      </div>
      <div>
        <div class="uk-card uk-card-default uk-card-body">
          <h3 class="uk-card-title">Dodatkowe uprawnienia</h3>
          <table class="uk-table uk-table-small uk-table-striped">
            <tr v-for="element in NFZElements">
              <td><strong>{{element.Opis}}</strong></td>
              <td>{{element.Wartosc}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="email-patient-reminder-modal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Zmiana adresu email</h2>
        <div id="error_empty_email" uk-alert class="uk-alert-danger" style="display: none;">
          <h3>Wystąpił błąd</h3>
          <p>Wprowadź poprawny adres email</p>
        </div>
        <div class="uk-margin">
          <input class="uk-input" type="email" placeholder="Twój aktualny email" v-model="newEmail">
        </div>
        <div class="uk-flex uk-flex-right">
          <button class="uk-button uk-button-default uk-modal-close uk-margin-small-left" type="button">Anuluj</button>
          <button @click="setEmail" class="uk-button uk-button-secondary uk-margin-small-left" type="button">Zapisz</button>
        </div>
      </div>
    </div>

    <div id="pass-change-modal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Zmiana hasła</h2>
        <div id="error_box_mismatch" uk-alert class="uk-alert-danger" style="display: none;">
          <h3>Wystąpił błąd</h3>
          <p>Podane hasła nie są takie same.</p>
        </div>
        <div id="error_box_characters" uk-alert class="uk-alert-danger" style="display: none;">
          <h3>Wystąpił błąd</h3>
          <p>Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.</p>
        </div>
        <div id="error_box_empty" uk-alert class="uk-alert-danger" style="display: none;">
          <h3>Wystąpił błąd</h3>
          <p>Proszę wprowadzić hasło.</p>
        </div>
        <div class="uk-margin">
          <!-- pass change -->
          <div class="uk-margin">
            <input class="uk-input" type="password" placeholder="Nowe hasło" v-model="credentials.passNew">
          </div>
          <div class="uk-margin">
            <input class="uk-input" type="password" placeholder="Powtórz nowe hasło" v-model="credentials.passNew_2">
          </div>
        </div>
        <div class="uk-flex uk-flex-right">
          <button class="uk-button uk-button-default uk-modal-close uk-margin-small-left" type="button">Anuluj</button>
          <button @click="setPass" class="uk-button uk-button-secondary uk-margin-small-left" type="button">Zapisz</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import UIkit from 'uikit'
import $ from 'jquery'
export default {
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      newEmail: '',
      id: '',
      credentials: {
        passNew_2: '',
        passNew: ''
      },
      Pacjent: {
        'IDPacjent': null,
        'IDPortal': null,
        'Nazwisko': null,
        'Imie': null,
        'Imie2': null,
        'PESEL': null,
        'DataUr': null,
        'MiejsceUr': null,
        'KodPocztowy': null,
        'Poczta': null,
        'Miejscowosc': null,
        'UlicaAlejaPlac': null,
        'Ulica': null,
        'NrDomu': null,
        'NrMieszkania': null,
        'Kraj': null,
        'KodPocztowy2': null,
        'Poczta2': null,
        'Miejscowosc2': null,
        'UlicaAlejaPlac2': null,
        'Ulica2': null,
        'NrDomu2': null,
        'NrMieszkania2': null,
        'Kraj2': null,
        'Tel': null,
        'TelKom': null,
        'Email': null
      },
      NFZElements: [
        {
          'IDPacjentNFZ': null,
          'IDPacjent': null,
          'IdNFZ': null,
          'Pole': null,
          'Wartosc': null,
          'Sciezka': null,
          'Opis': null
        }
      ],
      error_box_empty: false,
      error_box_characters: false,
      error_box_mismatch: false
    }
  },
  mounted: function () {
    $('#sliderMain').css('display', 'none')
    $('#backbtn').css('display', 'none')
    $('#notifications').css('display', 'none')
    $('.session-info-wrap').css('width', '100%')
    if (this.$cookie.get('aut')) {
      if (this.$cookie.get('cdata')) {
        this.firstName = $.parseJSON(this.$cookie.get('cdata')).name
        this.lastName = $.parseJSON(this.$cookie.get('cdata')).lastname
        this.email = $.parseJSON(this.$cookie.get('cdata')).email
        this.id = $.parseJSON(this.$cookie.get('cdata')).id
      }
    }
    this.credentials.passNew_2 = ''
    this.credentials.passNew = ''
    this.newEmail = this.email

    const vm = this
    var token = this.$cookie.get('aut')
    const data = { 'input': { 'data': { 'Token': token } } }
    vm.$http.post('/api.php?url=PacjentData', data, { headers: { 'Content-Type': 'application/json' } }).then(response => {
      var odp = response.data
      vm.Pacjent = odp.d.Pacjent
      vm.NFZElements = odp.d.NFZElements
    }).catch(err => {
      if (err.status === 400) {
        UIkit.modal.alert('Nieprawidłowe dane.')
      } else {
        UIkit.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką')
      }
    })
  },
  methods: {
    setEmail () {
      const vm = this
      var regex = /^.+@.+$/
      if (vm.newEmail === '' || !regex.test(vm.newEmail)) {
        $('#email-patient-reminder-modal #error_empty_email').show()
        return
      } else {
        $('#email-patient-reminder-modal #error_empty_email').hide()
        var token = this.$cookie.get('aut')
        const data = { 'request': { 'Id': vm.id, 'Token': token, 'Email': vm.newEmail } }
        vm.$http.post('/api.php?url=SetEmail', data, { headers: { 'Content-Type': 'application/json' } }).then(response => {
          var cdata = $.parseJSON(this.$cookie.get('cdata'))
          cdata.email = vm.newEmail
          vm.email = vm.newEmail
          this.$cookie.set('cdata', JSON.stringify(cdata), { expires: '1D' })
          UIkit.modal.alert('Dziękujemy.')
        }).catch(err => {
          if (err.status === 400) {
            UIkit.modal.alert('Nieprawidłowe dane.')
          } else {
            UIkit.modal.alert('Coś poszło nie tak. W razie dalszych problemów, prosimy o kontakt mailowy z kliniką')
          }
        })
      }
    },
    setPass () {
      $('#pass-change-modal #error_box_empty').hide()
      $('#pass-change-modal #error_box_characters').hide()
      $('#pass-change-modal #error_box_mismatch').hide()

      if (this.credentials.passNew && this.credentials.passNew_2) {
        var token = this.$cookie.get('aut')
        var setPassRequest = { 'request': { 'Id': this.id, 'NewPass': this.credentials.passNew_2, 'Token': token } }
        var reg = /^(?=.*\d)(?=.*[!@#$%^&*()+-={}|:<>?';.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
        if (this.credentials.passNew !== this.credentials.passNew_2) {
          $('#pass-change-modal #error_box_mismatch').show()
        } else if (reg.test(this.credentials.passNew)) {
          // new pass validate ok
          this.$http.post('/api.php?url=SetPass', setPassRequest, { headers: { 'Content-Type': 'application/json' } }).then((response) => {
            // var odp = response.data
            // var token = odp.d.data.TOKEN
            // this.$cookie.set('aut', token, { expires: '20m' })
            // if (this.$cookie.get('aut')) {
            UIkit.modal.alert('Hasło zostało poprawnie zmienione.')
            this.credentials.passNew_2 = ''
            this.credentials.passNew = ''
          }).catch((errors) => {
            this.credentials.passNew_2 = ''
            this.credentials.passNew = ''
            JSON.stringify(errors)
            UIkit.modal.alert('Wystąpił problem przy zmianie hasła, prosimy o kontakt z kliniką jeżeli problem będzie się powtarzał.')
          })
        } else {
          $('#pass-change-modal #error_box_characters').show()
        }
      } else {
        $('#pass-change-modal #error_box_empty').show()
      }
    }
  }
}
</script>

<style lang="sass" scoped>

  .table-holder
    max-height: 400px
    overflow-y: scroll

  .func-btn
    width: 40px
    padding: 0 10px

  tr > :first-child
    width: 12em;

  /*tr
    cursor: pointer*/



  .see-more-btn

    @media screen and (max-width: 555px)
      height: 50px

    @media screen and (max-width: 430px)
      height: 71px

</style>



// WEBPACK FOOTER //
// Data.vue?5c0ed77c